import { render, staticRenderFns } from "./NotificationSettingsContainer.vue?vue&type=template&id=5168dee7&"
import script from "./NotificationSettingsContainer.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports